import { Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface GroupBuyTooltipBadgeProps {
  className?: string;
  size?: 'sm' | 'md';
}

export const GroupBuyTooltipBadge = ({ className, size = 'md' }: GroupBuyTooltipBadgeProps) => {
  const badgeContent = (
    <Badge
      className={cn(
        "bg-gradient-to-r from-amber-500 to-yellow-400 text-white shadow-lg cursor-help",
        size === 'sm' ? 'text-xs px-2 py-0.5' : '',
        className
      )}
    >
      <Users className={cn("mr-1", size === 'sm' ? 'w-3 h-3' : 'w-3 h-3')} />
      קבוצת רכישה
    </Badge>
  );

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
            {badgeContent}
          </div>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          className="max-w-xs text-right bg-popover border border-border shadow-lg p-3"
          dir="rtl"
        >
          <div className="space-y-2">
            <p className="font-semibold text-sm">מהי קבוצת רכישה?</p>
            <p className="text-xs leading-relaxed">
              התאגדות צרכנים לרכישת כמות גדולה יחד במחיר מוזל במיוחד.
            </p>
            <div className="pt-2 border-t text-xs space-y-1">
              <p>✓ המוצר יסופק רק בהגעה ליעד</p>
              <p>✓ החזר מלא אם לא נגיע ליעד</p>
              <p>✓ אספקה משוערת: 30-90 יום מהגעה ליעד</p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
